const validateShipmentRow = (row) => {
  const container = String(row.containerNo || "").trim();
  if (!/^[A-Z]{4}[0-9]{7}$/.test(container)) {
    return "Container No must contain exactly 4 letters followed by 7 digits (for example ABCD1234567).";
  }
  if (row.eta && !row.etd) return "Enter ETD before entering ETA.";
  if (row.etd && row.eta) {
    const etd = Date.parse(row.etd);
    const eta = Date.parse(row.eta);
    if (!Number.isFinite(etd) || !Number.isFinite(eta) || eta <= etd) {
      return `ETA must be after ETD for container ${container}.`;
    }
  }
  return "";
};

export { validateShipmentRow };
